import { NavLink } from "react-router";
import FondsListComponent from "../../components/Fonds/FondsList";
import { useTrads } from "../../contexts/trads/useTrads";
import { useAuth } from "../../contexts/auth/useAuth";
import { roles } from "../../types/Users";
function FondsList(){
    const {translate}=useTrads();
    const { hasRole } = useAuth();
  return (
  <div>
    {hasRole(roles.Manager)?
    <nav>
        <NavLink className="btn btn-primary mt-3" to={`/fond/add`}>{translate('btn_add')}</NavLink>
    </nav>
    :null}
    <FondsListComponent  />
  </div>
  );
}
export default FondsList;